import * as XLSX from 'xlsx'

export const downloadXLSX = (data, baseFilename = 'wog-contacts') => {
  if (!data || !data.length) return

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data)

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  // Format filename with timestamp
  const now = new Date()
  const timestamp = now.toISOString()
    .replace(/T/, '_')
    .replace(/:/g, '-')
    .replace(/\..+/, '')

  const filename = `${baseFilename}-${timestamp}.xlsx`

  // Write file
  XLSX.writeFile(workbook, filename)
}
